import { createContext, useContext, useReducer } from "react";
import { faker } from "@faker-js/faker";
import { cartReducer, cartReducer2, cartReducer3, productReducer } from "./Reducer";
const Cart = createContext();

const Context = ({ children }) => {
  const products = [
    
    {
      image: "./images/IMG-20230122-WA0011.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5681",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0012.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5682",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230125-WA0006.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5683",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230125-WA0007.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5684",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230125-WA0008.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5685",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230125-WA0009.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5686",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0025.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5687",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0024.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5688",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0023.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5689",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0022.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56810",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0021.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56801",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0020.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56802",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0019.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56803",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0027.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56804",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0017.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56805",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0016.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56806",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0014.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56807",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230122-WA0013.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56808",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230125-WA0005.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56809",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230125-WA0004.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568010",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230125-WA0003.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568011",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230125-WA0002.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568012",

      name: "Curtain Finials",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
  ];

  const product2 = [
    {
      image: "./images/IMG-20230116-WA0022.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5680112",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230116-WA0024.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56802454",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230116-WA0026.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568034w3",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/Silent-Curtain-Channel-1.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5680grg",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/I-Curtain-Channel-4.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5680hrt4",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/Curtain-M-Channel-2.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56804656",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/Jumbo-Curtain-Channel-3.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568055yy",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/channels5.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56805gre",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230116-WA0028.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56805644r",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230116-WA0029.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5680t45",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image:
        "./images/N84Sg5fuvbqy59HRWktRMVc1N57iAnWXyCIuYB4uTcU=_plaintext_638094839468574086.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568046t",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/WhatsApp Image 2023-01-17 at 22.40.00.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5680t45t",
      name: "Curtain Channels",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
  ];
  const product3 = [
    {
      image: "./images/IMG-20230117-WA0031.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5680ergr",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230117-WA0032.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5680345r4",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230117-WA0033.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56804re34",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230117-WA0034.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568043t",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230117-WA0035.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5680jrb",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230117-WA0044.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e56804r4",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230117-WA0040.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e5680wd",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230117-WA0048.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568034",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230117-WA0045.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568045",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
    {
      image: "./images/IMG-20230117-WA0037.jpg",
      id: "d78c0255-3412-41c5-a13d-97709b1e568054t",
      name: "Window Blinds",
      price: "737.00",
      inStock: 7,
      ratings: 3,
    },
  ];

  const [state, dispatch] = useReducer(cartReducer, {
    products: products,
    cart: [],
  });
  const [state2, dispatch2] = useReducer(cartReducer2, {
    product2: product2,
    cart: [],
  });
  const [state3, dispatch3] = useReducer(cartReducer3, {
    product3: product3,
    cart: [],
  });
  const [productState, productDispatch] = useReducer(productReducer, {
    byStock: false,
    byFastDelivery: false,
    byRating: 0,
    searchQuery: "",
  });

//   console.log(product2);
  return (
    <Cart.Provider value={{ state, dispatch, state2, dispatch2,state3,dispatch3,productState, productDispatch }}>
      {children}
    </Cart.Provider>
  );
};

export default Context;

export const CartState = () => {
  return useContext(Cart);
};
